import React from 'react';
import { LayoutDashboard, MessageSquareCode, Settings, LogOut, Shield, Download } from 'lucide-react';

interface SidebarProps {
    currentScreen: string;
    isAdmin?: boolean;
    onNavigate: (screen: 'dashboard' | 'setup' | 'interaction' | 'feedback' | 'settings' | 'admin' | 'export') => void;
    onLogout: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ currentScreen, isAdmin, onNavigate, onLogout }) => {
    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                <h1>Simulate 2</h1>
                <p className="subtitle">by Inspiro</p>
            </div>

            <nav className="sidebar-nav">
                <div
                    className={`nav-item ${currentScreen === 'dashboard' ? 'active' : ''}`}
                    onClick={() => onNavigate('dashboard')}
                >
                    <LayoutDashboard size={20} />
                    <span>Dashboard</span>
                </div>

                <div
                    className={`nav-item ${['setup', 'interaction', 'feedback'].includes(currentScreen) ? 'active' : ''}`}
                    onClick={() => onNavigate('setup')}
                >
                    <MessageSquareCode size={20} />
                    <span>Simulation</span>
                </div>

                {isAdmin && (
                    <>
                        <div
                            className={`nav-item ${currentScreen === 'admin' ? 'active' : ''}`}
                            onClick={() => onNavigate('admin')}
                        >
                            <Shield size={20} />
                            <span>Admin Panel</span>
                        </div>
                        <div
                            className={`nav-item ${currentScreen === 'export' ? 'active' : ''}`}
                            onClick={() => onNavigate('export')}
                        >
                            <Download size={20} />
                            <span>Export Portal</span>
                        </div>
                    </>
                )}

                <div
                    className={`nav-item ${currentScreen === 'settings' ? 'active' : ''}`}
                    onClick={() => onNavigate('settings')}
                >
                    <Settings size={20} />
                    <span>Settings</span>
                </div>
            </nav>

            <div className="sidebar-footer">
                <div className="nav-item" onClick={onLogout} style={{ color: '#FB7185' }}>
                    <LogOut size={20} />
                    <span>Log Out</span>
                </div>
                <div style={{ marginTop: '1.25rem', padding: '0 0.25rem', fontSize: '0.72rem', color: 'rgba(255, 255, 255, 0.4)', textAlign: 'center', lineHeight: '1.4', letterSpacing: '0.01em' }}>
                    &copy; 2025 Simulate 2 • High-Performance AI Coaching
                </div>
            </div>
        </aside>
    );
};
